module.exports = __webpack_public_path__ + "img/minus_icon.c74c2987.svg";